<template>
  <div>
    <!-- 通信結果表示用 -->
    <modal
      name="send-complate-modal"
      width="100%"
      height="auto"
      :max-width="800"
      :adaptive="true"      
      styles="
      background: rgba(255, 255, 255, .85);
      border-radius: 10px;"
    >
      <div class="modal modal-confirm">
        <div class="modal-content">
          <div class="modal-body al-center" style="white-space: pre-wrap;">{{ sendResultMessage }}</div>
          <section class="modal-bottom-button">
            <a class="bt-ok bt" v-on:click="hideResultSendInspectionModal()"
              >ＯＫ</a
            >
          </section>
        </div>
        <!--/.modal-content-->
      </div>
      <!--/.modal-->
    </modal>

    <!-- リンク付き通信結果表示用 -->
    <modal
      name="send-complate-modal-with-link"
      width="100%"
      height="auto"
      :max-width="800"
      :adaptive="true"      
      styles="
      background: rgba(255, 255, 255, .85);
      border-radius: 10px;"
    >
      <div class="modal modal-confirm">
        <div class="modal-content">
          <div class="modal-body al-center" style="white-space: pre-wrap;">{{ sendResultMessage }}<br/><a :href="`${getInquiryLinkOfSendMailFailed()}`" style="text-decoration:underline;">問い合わせフォームへ</a></div>
          <section class="modal-bottom-button">
            <a class="bt-ok bt" v-on:click="hideResultSendInspectionMadalWithLink()"
              >ＯＫ</a
            >
          </section>
        </div>
        <!--/.modal-content-->
      </div>
      <!--/.modal-->
    </modal>
  </div>
</template>
<script>
export default {
  name: 'ResultModal',
  data () {
    return {
      sendResultMessage: '',      
      isReturnNotice: false
    }
  },
  methods: {
    showResultSendInspectionModal: function (message, isReturnNotice) {
      this.isReturnNotice = isReturnNotice;
      this.sendResultMessage = message;
      this.$modal.show('send-complate-modal');      
    },
    hideResultSendInspectionModal: function () {
      this.$modal.hide('send-complate-modal')
      if (this.isReturnNotice) {
        this.$emit('pushOkButton') // 呼び出し画面に通知を行う
      }
    },
    showResultSendInspectionModalWithLink: function (message, isReturnNotice) {
      this.isReturnNotice = isReturnNotice
      this.sendResultMessage = message
      this.$modal.show('send-complate-modal-with-link')
    },
    hideResultSendInspectionMadalWithLink: function () {
      this.$modal.hide('send-complate-modal-with-link')
      if (this.isReturnNotice) {
        this.$emit('pushOkButton') // 呼び出し画面に通知を行う
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ResultModal.vue